export default __webpack_public_path__ + "static/media/ispLG.60b80690.png";